import styled from "styled-components";
import { Modal } from "react-bootstrap";
import { Search } from "@styled-icons/boxicons-regular/Search";
import { Delete } from "@styled-icons/fluentui-system-filled/Delete";
import { EditAlt } from "@styled-icons/boxicons-regular/EditAlt";


export const MainWrapper = styled.div`
  background-color: #f5f5f5;
  width: 100%;
  min-height: 100vh;
  color: #fff;

  .dropdown-item {
    color: #333 !important;
  }

  .bgdark {
    background-color: #007bc6;
    margin-left: -15px;

    a {
      background-color: #05367f;
      margin-bottom: 1px;
      color: #fff;
    }

    hr{
      border-top: 1px solid #3b95f2;
      margin: 10px 0px;
    }
  }

  .btn-primary{
    background-color: #05367f;
    display: block;
    border: 0px;
    width: 100%;
  }

  .card {
    margin: 15px 0px;
  }
`;

export const MainContent = styled.div`
  background-color: #fff;
  padding: 15px;
  display: block;
  margin: 10px 0px;
  color: #333;

  .pull-right{
    position: relative;
    float: right;
  }
`;


export const SearchIcon = styled(Search)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;


export const DeleteIcon = styled(Delete)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;


export const EditIcon = styled(EditAlt)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;



/* ---------------------------------------------------------------------------
   Modal de cadastro/edição de usuário.
   Grade de duas colunas para o formulário não virar uma coluna longa demais;
   colapsa para uma coluna em tela estreita.
   --------------------------------------------------------------------------- */

export const ModalCabecalho = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;

  @media (max-width: 640px) {
    gap: 11px;

    h5 {
      font-size: 16px;
    }

    p {
      font-size: 11.5px;
    }
  }

  .icone {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: linear-gradient(135deg, #024995 0%, #009bd9 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 5px 14px rgba(2, 73, 149, 0.26);

    i {
      color: #fff;
      font-size: 18px;
    }
  }

  h5 {
    margin: 0 0 2px;
    font-size: 18px;
    font-weight: 800;
    color: #1a2740;
  }

  p {
    margin: 0;
    font-size: 12.5px;
    color: #8698ab;
  }
`;

export const Secao = styled.section`
  & + & {
    margin-top: 22px;
  }
`;

export const SecaoTitulo = styled.h6`
  display: flex;
  align-items: center;
  gap: 9px;
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #8698ab;
  margin: 0 0 12px;

  i {
    color: #009bd9;
    font-size: 12px;
  }

  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #eef2f7;
  }
`;

export const Grade = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

/* Ocupa a linha inteira da grade (nome, senha, avisos). */
export const Inteiro = styled.div`
  grid-column: 1 / -1;
`;

export const CampoForm = styled.div<{ $erro?: boolean }>`
  min-width: 0;

  label {
    display: block;
    font-size: 10.5px;
    font-weight: 800;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    color: #8698ab;
    margin-bottom: 6px;
  }

  .form-control,
  input,
  select {
    width: 100%;
    border: 1.5px solid ${(p) => (p.$erro ? "#dc3545" : "#e8eef5")} !important;
    border-radius: 10px !important;
    padding: 10px 13px !important;
    font-size: 13.5px !important;
    height: 42px;
    background: ${(p) => (p.$erro ? "#fffafa" : "#f7fafd")} !important;
    color: #1a2740 !important;
    box-shadow: none !important;
    font-family: inherit;

    &::placeholder {
      color: #b3c1d1;
    }

    &:focus {
      border-color: ${(p) => (p.$erro ? "#dc3545" : "#009bd9")} !important;
      background: #fff !important;
      box-shadow: 0 0 0 3px
        ${(p) => (p.$erro ? "rgba(220,53,69,0.12)" : "rgba(0,155,217,0.12)")} !important;
    }
  }

  select {
    cursor: pointer;
  }

  .erro {
    display: block;
    font-size: 11.5px;
    color: #a12727;
    font-weight: 600;
    margin-top: 5px;
  }
`;

/* Requisitos da senha em linha, para não empilhar cinco itens. */
export const RequisitosSenha = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
`;

export const Requisito = styled.span<{ $ok: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 9px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  background: ${(p) => (p.$ok ? "#eafaf1" : "#f4f6f9")};
  border: 1px solid ${(p) => (p.$ok ? "#b7e4c7" : "#e3e8ee")};
  color: ${(p) => (p.$ok ? "#1b7a4b" : "#8698ab")};
  transition: all 0.18s ease;

  i {
    font-size: 9px;
  }
`;

/* Bloco do responsável: só aparece para estudante. */
export const AvisoSenha = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 11px;
  background: #eef6fd;
  border: 1px solid #c5e0f7;
  border-left: 4px solid #009bd9;
  border-radius: 10px;
  padding: 13px 16px;
  font-size: 12.5px;
  line-height: 1.55;
  color: #33475e;

  i {
    color: #009bd9;
    font-size: 14px;
    margin-top: 1px;
    flex-shrink: 0;
  }

  strong {
    color: #024995;
  }
`;

export const BlocoResponsavel = styled.div`
  background: #f7fafd;
  border: 1px solid #e3ecf5;
  border-left: 4px solid #009bd9;
  border-radius: 12px;
  padding: 16px 18px;

  .aviso {
    font-size: 12.5px;
    line-height: 1.55;
    color: #5b6b7e;
    margin: 0 0 14px;
  }
`;

export const ModalRodape = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  width: 100%;

  @media (max-width: 640px) {
    flex-direction: column-reverse;
  }
`;


/*
  O Modal do react-bootstrap renderiza em portal, então styled-components num
  ancestral não o alcança. Aplicando o className no proprio Modal (que vai para o
  elemento .modal) dá para alcançar .modal-dialog / .modal-content por dentro.
*/
export const ModalUsuario = styled(Modal)`
  /*
    O react-bootstrap injeta padding-left/right inline no .modal para compensar a
    barra de rolagem que some ao abrir. Com o corpo rolando por dentro (scrollable)
    não há o que compensar, e esse padding só tira o modal do centro. Precisa de
    !important porque o valor vem em style inline.
  */
  &&& {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .modal-dialog {
    max-width: 720px;
  }

  .modal-content {
    border: none;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 24px 60px rgba(2, 73, 149, 0.22);
  }

  .modal-header {
    border-bottom: 1px solid #eef2f7;
    padding: 18px 22px;
    align-items: center;

    .close {
      padding: 0;
      margin: 0 0 0 auto;
      font-size: 26px;
      font-weight: 400;
      color: #8698ab;
      opacity: 1;
      text-shadow: none;

      &:hover {
        color: #1a2740;
      }
    }
  }

  .modal-body {
    padding: 22px;
  }

  .modal-footer {
    border-top: 1px solid #eef2f7;
    padding: 16px 22px;
    background: #fafcfe;
  }

  .btn {
    border-radius: 9px;
    font-weight: 700;
    font-size: 13.5px;
    padding: 9px 18px;
  }

  /* Telas estreitas: o modal ocupa a largura útil e a barra de ações empilha. */
  @media (max-width: 640px) {
    .modal-dialog {
      margin: 10px;
      max-width: calc(100% - 20px);
    }

    .modal-header {
      padding: 14px 16px;
    }

    .modal-body {
      padding: 16px;
    }

    .modal-footer {
      padding: 14px 16px;
    }

    .btn {
      width: 100%;
    }
  }
`;


/*
  Cabeçalho da página. Em telas estreitas o contador (fonte display-4) não encolhia
  e empurrava o bloco para fora do card, esticando o documento inteiro — o que por
  sua vez inflava a viewport de layout e desalinhava tudo, inclusive os modais.
*/
export const CabecalhoPagina = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;

  .identidade {
    display: flex;
    align-items: center;
    min-width: 0;
    flex: 1 1 260px;

    i {
      font-size: 2rem;
      flex-shrink: 0;
    }

    h3 {
      overflow-wrap: anywhere;
    }
  }

  .contador {
    text-align: right;
    min-width: 0;
    flex: 0 1 auto;

    .numero {
      font-size: 3.2rem;
      line-height: 1;
      font-weight: 700;
    }
  }

  @media (max-width: 640px) {
    gap: 12px;

    .identidade {
      flex: 1 1 100%;

      i {
        font-size: 1.6rem;
      }

      h3 {
        font-size: 1.25rem;
      }

      p {
        font-size: 0.85rem;
      }
    }

    .contador {
      flex: 1 1 100%;
      text-align: left;

      .numero {
        font-size: 2.1rem;
      }
    }
  }
`;
